module.exports = __webpack_public_path__ + "img/daops.22a1718f.png";